import Image from "next/image";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";

interface ExtrasAccordionContent {
  title: string;
  description: string;
  icon: string;
}

interface ExtrasAccordionProps {
  extrasAccordionContent: Readonly<ExtrasAccordionContent[]>;
}

export default function ExtrasAccordion({
  extrasAccordionContent,
}: Readonly<ExtrasAccordionProps>) {
  return (
    <Accordion type="multiple" className="w-full">
      {extrasAccordionContent.map((option, index) => (
        <AccordionItem
          key={option.title}
          value={option.title}
          className="w-full transition ease-in-out hover:border-b-0 duration-800 hover:shadow-lg hover:rounded-lg"
        >
          <AccordionTrigger
            className="w-full cursor-pointer px-3 py-2.5 decoration-none hover:no-underline! [&_svg]:h-6 [&_svg]:w-6 [&_svg]:stroke-1"
            data-testid={`extra-accordion-${index}-trigger-btn`}
          >
            <div className="flex items-start justify-between w-full gap-4 text-left">
              <div className="flex items-start gap-2 text-sm font-medium text-brand-blue md:items-center">
                <Image src={option.icon} width={35} height={35} alt="logo" />
                <span className="font-sans text-base font-semibold text-left text-brand-blue line-clamp-2">
                  {option.title}
                </span>
              </div>
            </div>
          </AccordionTrigger>
          <AccordionContent
            className="px-3 py-2 space-y-1 text-sm text-brand-blue"
            data-testid={`extra-accordion-${index}-content`}
          >
            <div className="flex justify-between font-normal">
              <span>{option.description}</span>
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
